import { Box, Link, Typography } from '@mui/material';
import { useCommon } from '~/utils/hook/useCommon';
import { StyledFooter } from './SiteFooter.style';

/**
 * 站台頁尾（版權、服務條款、版權聲明、遠端連線）。
 *
 * 原本寫在 Resource.tsx 的 renderFooter 裡，離線時取得資源頁改渲染
 * OfflineState、整個 Resource 元件不掛載，頁尾也跟著不見。設計稿要求離線頁
 * 仍要有，所以抽成共用元件讓兩邊都能用。
 *
 * 離線可用性：版權聲明走本機對話框；兩個外部連結在斷網時點了不會有反應，
 * 但設計稿選擇保留，不特別隱藏。
 */
export const SiteFooter = () => {
  const { copyRightAlert } = useCommon();

  return (
    <StyledFooter
      sx={{
        flexDirection: 'column',
        justifyContent: 'center',
        gap: '8px',
        height: 'auto',
        py: 2,
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        {/* Desktop */}
        <Typography
          variant="body1"
          sx={{
            display: 'block',
            '@media (max-width: 768px)': { display: 'none' },
          }}
        >
          南一書局企業股份有限公司 Copyright © {new Date().getFullYear()} NAN I
          BOOK ENTERPRISE CO., LTD. All Rights Reserved.
        </Typography>
        {/* Tablet */}
        <Typography
          variant="body1"
          sx={{
            display: 'none',
            '@media (max-width: 768px)': { display: 'block' },
            '@media (max-width: 480px)': { display: 'none' },
          }}
        >
          南一書局企業股份有限公司
          <br />
          Copyright © {new Date().getFullYear()} NAN I BOOK ENTERPRISE CO., LTD.
          All Rights Reserved.
        </Typography>
        {/* Mobile */}
        <Typography
          variant="body1"
          sx={{
            display: 'none',
            '@media (max-width: 480px)': { display: 'block' },
          }}
        >
          南一書局企業股份有限公司 Copyright
          <br />© {new Date().getFullYear()} NAN I BOOK ENTERPRISE CO., LTD.
          <br />
          All Rights Reserved.
        </Typography>
      </Box>

      <Box sx={{ textAlign: 'center' }}>
        {/* Desktop & Tablet Links */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            '@media (max-width: 480px)': { display: 'none' },
          }}
        >
          <Link
            variant="body1"
            href="https://docs.nani.com.tw/pricing-licensing/index.html"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          >
            數位教學服務授權金額與服務條款
          </Link>
          <Typography variant="body1" component="span">
            |
          </Typography>
          <Typography
            variant="body1"
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={copyRightAlert}
          >
            版權聲明
          </Typography>
          <Typography variant="body1" component="span">
            |
          </Typography>
          <Link
            variant="body1"
            sx={{ userSelect: 'none', cursor: 'pointer' }}
            href="https://cdn.nani.cool/download/%E5%8D%97%E4%B8%80%E9%81%A0%E7%AB%AF%E9%80%A3%E7%B7%9A.exe"
            title="以 TeamViewer 進行遠端連線"
            download
          >
            遠端連線
          </Link>
        </Box>

        {/* Mobile Links */}
        <Box
          sx={{
            display: 'none',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '4px',
            '@media (max-width: 480px)': { display: 'flex' },
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Link
              variant="body1"
              href="https://docs.nani.com.tw/pricing-licensing/index.html"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            >
              數位教學服務授權金額與服務條款
            </Link>
            <Typography variant="body1" component="span">
              |
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Typography
              variant="body1"
              sx={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={copyRightAlert}
            >
              版權聲明
            </Typography>
            <Typography variant="body1" component="span">
              |
            </Typography>
            <Link
              variant="body1"
              sx={{ userSelect: 'none', cursor: 'pointer' }}
              href="https://cdn.nani.cool/download/%E5%8D%97%E4%B8%80%E9%81%A0%E7%AB%AF%E9%80%A3%E7%B7%9A.exe"
              title="以 TeamViewer 進行遠端連線"
              download
            >
              遠端連線
            </Link>
          </Box>
        </Box>
      </Box>
    </StyledFooter>
  );
};
